import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-fluid px-0"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 col-xxl-3 mb-6" }
const _hoisted_5 = { class: "card card-flush border" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "d-flex mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-diagram-3 fs-2x me-4 text-primary" }, null, -1)
const _hoisted_9 = { class: "d-flex justify-content-between align-items-baseline" }
const _hoisted_10 = { class: "me-5 min-w-50px" }
const _hoisted_11 = { class: "fs-3x" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right text-primary fs-3 ms-3" }, null, -1)
const _hoisted_13 = { class: "col-md-6 col-xxl-3 mb-6" }
const _hoisted_14 = { class: "card card-flush border" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "d-flex mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-layers fs-2x me-4 text-primary" }, null, -1)
const _hoisted_18 = { class: "d-flex justify-content-between align-items-baseline" }
const _hoisted_19 = { class: "me-5 min-w-50px" }
const _hoisted_20 = { class: "fs-3x" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right text-primary fs-3 ms-3" }, null, -1)
const _hoisted_22 = { class: "col-md-6 col-xxl-3 mb-6" }
const _hoisted_23 = { class: "card card-flush border" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "d-flex mb-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people fs-2x me-4 text-primary" }, null, -1)
const _hoisted_27 = { class: "d-flex justify-content-between align-items-baseline" }
const _hoisted_28 = { class: "me-5 min-w-50px" }
const _hoisted_29 = { class: "fs-3x" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right text-primary fs-3 ms-3" }, null, -1)
const _hoisted_31 = { class: "col-md-6 col-xxl-3 mb-6" }
const _hoisted_32 = { class: "card card-flush border" }
const _hoisted_33 = { class: "card-body" }
const _hoisted_34 = { class: "d-flex mb-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cpu fs-2x me-4 text-primary" }, null, -1)
const _hoisted_36 = { class: "d-flex justify-content-between align-items-baseline" }
const _hoisted_37 = { class: "me-5 min-w-50px" }
const _hoisted_38 = { class: "fs-3x" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right text-primary fs-3 ms-3" }, null, -1)
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = { class: "card card-flush h-xxl-100 border" }
const _hoisted_43 = { class: "card-header pt-7" }
const _hoisted_44 = { class: "card-title align-items-start flex-column" }
const _hoisted_45 = { class: "card-label fw-bolder text-gray-800" }
const _hoisted_46 = { class: "card-body d-flex flex-column justify-content-between pb-5" }
const _hoisted_47 = {
  id: "chart",
  class: "w-100"
}
const _hoisted_48 = { class: "text-truncate" }
const _hoisted_49 = { class: "text-truncate" }
const _hoisted_50 = { class: "text-truncate me-3" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { class: "text-truncate me-3" }
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = { class: "text-truncate me-3" }
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-line" }, null, -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-toggle": "dropdown",
  class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-circle btn-sm ms-3",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-v fs-5" })
], -1)
const _hoisted_63 = { class: "dropdown-menu dropdown-menu-end border detail-dropdown" }
const _hoisted_64 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_SiteDetailModal = _resolveComponent("SiteDetailModal")!
  const _component_ViewSiteDetailModal = _resolveComponent("ViewSiteDetailModal")!
  const _component_LineChartModal = _resolveComponent("LineChartModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
                    _ctx.checkPermission('VYZOR:BUSINESS:SITE:READ', 'site')
                  ), ["prevent"])),
                  class: "text-gray-800 fw-bolder text-hover-primary fs-2"
                }, _toDisplayString(_ctx.t("common.sites")), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.siteCount), 1)
                ]),
                (_ctx.hasPermissionWrapper(_ctx.VZ_PERMISSIONS.BUSINESS_SITE))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/branch",
                      class: "d-flex align-items-center fs-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("common.viewAll")) + " ", 1),
                        _hoisted_12
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
                    _ctx.checkPermission(
                      'VYZOR:TEMPLATES:FORMS:READ',
                      'form.definition'
                    )
                  ), ["prevent"])),
                  class: "text-gray-800 fw-bolder text-hover-primary fs-2"
                }, _toDisplayString(_ctx.t("common.forms")), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h1", _hoisted_20, _toDisplayString(_ctx.formCount), 1)
                ]),
                (_ctx.hasPermissionWrapper(_ctx.VZ_PERMISSIONS.TEMPLATES_FORMS))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/form",
                      class: "fs-4 d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("common.viewAll")) + " ", 1),
                        _hoisted_21
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                    _ctx.checkPermission('VYZOR:USERS:USERS:READ', 'user')
                  ), ["prevent"])),
                  class: "text-gray-800 fw-bolder text-hover-primary fs-2"
                }, _toDisplayString(_ctx.t("common.users")), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h1", _hoisted_29, _toDisplayString(_ctx.userCount), 1)
                ]),
                (_ctx.hasPermissionWrapper(_ctx.VZ_PERMISSIONS.USERS_USERS))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/user",
                      class: "d-flex align-items-center fs-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("common.viewAll")) + " ", 1),
                        _hoisted_30
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                    _ctx.checkPermission(
                      'VYZOR:INTEGRATIONS:DEVICES:READ',
                      'devices'
                    )
                  ), ["prevent"])),
                  class: "text-gray-800 fw-bolder text-hover-primary fs-2"
                }, _toDisplayString(_ctx.t("pages.site.device")), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("h1", _hoisted_38, _toDisplayString(_ctx.deviceCount), 1)
                ]),
                (
                    _ctx.hasPermissionWrapper(_ctx.VZ_PERMISSIONS.INTEGRATIONS_DEVICES)
                  )
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/devices",
                      class: "fs-4 d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("common.viewAll")) + " ", 1),
                        _hoisted_39
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("h3", _hoisted_44, [
                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.t("common.branchesFormCategories")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_apexchart, {
                  type: "bar",
                  height: "350",
                  options: _ctx.chartOptions,
                  series: _ctx.series
                }, null, 8, ["options", "series"])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Datatable, {
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        total: _ctx.total,
        rowsPerPage: _ctx.rowsPerPage,
        page: _ctx.page,
        loading: _ctx.loading,
        showSearch: _ctx.showSearch,
        defaultFilter: _ctx.defaultFilter,
        tableFilter: _ctx.tableFilter,
        viewName: "sites-table-dashboard",
        onQueryUpdate: _ctx.queryUpdate,
        onTableRowClick: _ctx.tableRowClick
      }, {
        "cell-siteName": _withCtx(({ row: site }) => [
          _createElementVNode("span", _hoisted_48, _toDisplayString(site.siteName), 1)
        ]),
        "cell-siteNumber": _withCtx(({ row: site }) => [
          _createElementVNode("span", _hoisted_49, _toDisplayString(site.siteNumber), 1)
        ]),
        "cell-onTime": _withCtx(({ row: site }) => [
          _createElementVNode("span", _hoisted_50, _toDisplayString(+site.onTime), 1),
          _createElementVNode("span", {
            innerHTML: _ctx.format.upDownIndicator(site.onTimePercentage, 'on-time')
          }, null, 8, _hoisted_51)
        ]),
        "cell-outsidePeriod": _withCtx(({ row: site }) => [
          _createElementVNode("span", _hoisted_52, _toDisplayString(+site.outsidePeriod), 1),
          _createElementVNode("span", {
            innerHTML: 
              _ctx.format.upDownIndicator(
                site.outsidePeriodPercentage,
                'outside-period'
              )
            
          }, null, 8, _hoisted_53)
        ]),
        "cell-expire": _withCtx(({ row: site }) => [
          _createElementVNode("span", _hoisted_54, _toDisplayString(+site.expire), 1),
          _createElementVNode("span", {
            innerHTML: _ctx.format.upDownIndicator(site.expirePercentage, 'expired')
          }, null, 8, _hoisted_55)
        ]),
        "cell-status": _withCtx(({ row: site }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["text-truncate fw-bolder", {
              'badge badge-success mt-2':
                site.status?.toLowerCase() === 'active',
              'badge badge-danger mt-2':
                site.status?.toLowerCase() !== 'active',
            }])
          }, _toDisplayString(_ctx.format.TitleCase(site.status?.toLowerCase())), 3)
        ]),
        "cell-actions": _withCtx(({ row: site }) => [
          _createElementVNode("a", {
            onClick: _withModifiers(($event: any) => (_ctx.openDetailModal('chart', site)), ["prevent"]),
            class: "btn btn-icon btn-info btn-circle btn-sm"
          }, _hoisted_58, 8, _hoisted_56),
          _createElementVNode("a", {
            onClick: _withModifiers(($event: any) => (_ctx.openViewModal(site)), ["prevent"]),
            class: "btn btn-icon btn-primary btn-circle btn-sm mx-3"
          }, _hoisted_61, 8, _hoisted_59),
          _hoisted_62,
          _createElementVNode("ul", _hoisted_63, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                onClick: _withModifiers(($event: any) => (_ctx.openDetailModal('detail', site)), ["prevent"]),
                class: "dropdown-item py-2 text-hover-primary",
                type: "button"
              }, _toDisplayString(_ctx.t("common.detail")), 9, _hoisted_64)
            ])
          ])
        ]),
        _: 1
      }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "onQueryUpdate", "onTableRowClick"]),
      _createVNode(_component_SiteDetailModal, {
        viewName: "site_detail_modal",
        data: _ctx.selectedSite,
        showDialog: _ctx.showDetailDialog,
        onCloseDetail: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDetailDialog = false))
      }, null, 8, ["data", "showDialog"]),
      _createVNode(_component_ViewSiteDetailModal, {
        viewName: "site_detail_modal",
        data: _ctx.viewSelectedSite,
        dateFilter: _ctx.dateFilterValue,
        showDialog: _ctx.showViewDetailDialog,
        onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showViewDetailDialog = false))
      }, null, 8, ["data", "dateFilter", "showDialog"]),
      _createVNode(_component_LineChartModal, {
        viewName: "site_line_chart_modal",
        data: _ctx.selectedSite,
        reference: "site",
        dateFilterValue: _ctx.dateFilterValue,
        title: _ctx.selectedSite.name || '',
        showDialog: _ctx.showChartDialog,
        onCloseChart: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showChartDialog = false))
      }, null, 8, ["data", "dateFilterValue", "title", "showDialog"])
    ])
  ]))
}